export default __webpack_public_path__ + "static/app-store-btn-b498a6baef0b14ee6732cd97de88147e.svg";